import { createFileRoute } from '@tanstack/react-router'
import { NewEmployeeDialogPending } from '@/routes/_app/-components/shared/dialog-pending'
import { useModalSlot } from '@/components/custom/modal-slot'
import EditEmployeeDialog from '@/routes/_app/-dialogs/edit-employee'

export const Route = createFileRoute('/@modal/employees/new')({
  staticData: { slotScope: '/_app' },
  pendingComponent: NewEmployeeDialogPending,
  component: NewEmployeeSlot,
})

function NewEmployeeSlot() {
  const slot = useModalSlot(Route)
  return <EditEmployeeDialog {...slot} />
}
